import { EmployeeServicePath, SICK_LEAVES } from "utils/constants";
import EditSickLeaves from "./Edit";
import pemissions from "app/permissions";

export const resources = {
  isMenu: false,
  name: EmployeeServicePath + "edit/" + SICK_LEAVES + "/:id",
  title: "Редакция на болничен",
  custom: <EditSickLeaves />,
  permission: pemissions.canUpdateLeaveRequests,
};
